import { render, staticRenderFns } from "./PerMv.vue?vue&type=template&id=3ee77c14&scoped=true"
import script from "./PerMv.vue?vue&type=script&lang=js"
export * from "./PerMv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee77c14",
  null
  
)

export default component.exports